import setHiddenSlides from '../../../../src/js/set-hidden-slides';

// eslint-disable-next-line no-undef
new Swiper('.block-collection-slider__slider', {
	slidesPerView: 1.2,
	spaceBetween: 12,
	loop: false,
	navigation: {
		nextEl: '.block-collection-slider__next',
		prevEl: '.block-collection-slider__prev',
	},
	breakpoints: {
		560: {
			slidesPerView: 2.2,
			spaceBetween: 16,
		},
		900: {
			slidesPerView: 3.2,
			spaceBetween: 24,
		},
	},
	a11y: {
		slideLabelMessage: 'slide {{index}} of {{slidesLength}}',
	},
	on: {
		init: setHiddenSlides,
		slideChangeTransitionEnd: setHiddenSlides,
		breakpoint: setHiddenSlides,
	},
});
